module.exports = __webpack_public_path__ + "img/album12_09.14c73004.jpg";